const showLoader = (state = false, action) => {
  if (action.type === "TOGGLE_LOADER") {
    return action.payload;
  } else {
    return state;
  }
  // switch (action.type) {
  //   case "TOGGLE_LOADER": {
  //     return action.payload;
  //   }

  //   default: {
  //     return state;
  //   }
  // }
};

export default showLoader;
